var loop=false;
var sides_count=$('#banner').find('a').size();

if(sides_count > 1){
    loop=true;
}

$(document).ready(function(){
    $("#banner").lightSlider({
        item: 1,
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        slideMargin: 10,
        loop: loop,
        auto: true,
        addClass: '',
        mode: "slide",
        useCSS: true,
        pager: false,
        pause: 6000,
        currentPagerPosition:'left',
        responsive : [
            {
                breakpoint:768,
                settings: {
                    item:1,
                    minSlide:1,
                    slideMove:1,
                    slideMargin:6,
                    autoWidth: false,
                    rtl:false,
                    adaptiveHeight:true,
                    controls: false
                }
            }
        ]
    });

    /* $("#banner").lightSlider({
     autoWidth: false,
     minSlide:1,
     maxSlide:1,
     item: 1,
     controls:true,
     auto:true,
     pause: 6000,

     slideMargin: 10,

     currentPagerPosition:'left'

     });*/

    $(".home-products-slider").lightSlider({
        item: 4,
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        slideMargin: 10,

        addClass: '',
        mode: "slide",
        useCSS: true,
        cssEasing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        easing: 'linear', //'for jquery animation',////

        speed: 2500, //ms'
        auto: false,
        loop: true,
        slideEndAnimatoin: true,
        pause: 5000,

        controls: true,
        prevHtml: '',
        nextHtml: '',
        pager: false,
        responsive : [
            {
                breakpoint: 970,
                settings: {
                    item: 3,
                    autoWidth: false,
                    loop: true,
                    slideMove: 1,
                    slideMargin: 6
                }
            },

            {
                breakpoint: 600,
                settings: {
                    item: 2,
                    autoWidth: false,
                    loop: true,
                    slideMove: 1,
                    slideMargin: 6,
                    controls: false
                }
            }

        ]
    });
});